import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=3b5572e4&"
import script from "./DateSelect.vue?vue&type=script&lang=ts&"
export * from "./DateSelect.vue?vue&type=script&lang=ts&"
import style0 from "./DateSelect.vue?vue&type=style&index=0&id=3b5572e4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VContainer,VDivider,VIcon})
